const B_1 = [
    {
        title: '获取报价得分',
        path: '/bidding/projectflow/kaibiao/getoffer/list'
    }
]
export default {
    path: 'getoffer',
    component: () => import(/*webpackChunkName: 'bidding-kai-getoffer'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/kai/get-offer/list'),
            meta: {
                title: '获取报价得分',
                bread: B_1
            },
        },
        {
            path:"selectnode",
            component: () => import('@views/bidding/views/project-flow/kai/get-offer/selectnode'),
            meta: {
                title: '选择报价步骤',
                bread: B_1
            },
        },
        {
            path:"selecttbdw",
            component: () => import('@views/bidding/views/project-flow/kai/get-offer/selecttbdw'),
            meta: {
                title: '计算报价得分',
                bread: B_1
            },
        },
    ]
}